import React from "react";
import style from "./index.module.scss";
import { Checkbox } from "antd";
import { OptionItem, TopicsItem } from "../../../../../service";

interface PageCheckBoxProps {
    index?: number;
    data: TopicsItem;
    stuDoFlg: string;
}

export default function PageCheckBoxDetail({
    data,
    stuDoFlg,
    index
}: PageCheckBoxProps) {
    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（多选题）</span>
            </div>
            <div className={style.title}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>
            <div className={style.options}>
                <Checkbox.Group value={JSON.parse(data.stuAns)}>
                    {data.options &&
                        data.options.map((item: OptionItem, index: number) => (
                            <Checkbox value={item.id} key={index} disabled>
                                <span className={style.letter}>
                                    {String.fromCharCode(65 + index)}.
                                </span>
                                <span
                                    className={style.spanHtml}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Checkbox>
                        ))}
                </Checkbox.Group>
            </div>
        </div>
    );
}
